import React from "react";
import Approved from "../partials/Approved";
import ATitle from "../components/ATitle";
import ProgressLine from "../components/ProgressLine";
import LinksBlock from "../partials/LinksBlock";
import StatusBlock from "../partials/StatusBlock";
import Submission from "../partials/Submission";

export default function () {
  return (
    <div className="dao product-ovr">
      <ATitle text="Product Voting Overview" href="/dao/product-voiting/" />
      <div className="product-ovr__mr">
        <div className="product-ovr__link">
          <a
            target="_blank"
            className="article-link"
            href="https://en.wikipedia.org/wiki/Cryptocurrency"
          >
            https://en.wikipedia.org/wiki/Cryptocurrency
          </a>
        </div>
        <div className="product-ovr__progress">
          <ProgressLine
            variant="outer"
            percent={(592845 / 3407155) * 100}
            firstNumber="592,845"
            secondNumber="3,407,155"
          />
        </div>
        <h3 className="product-ovr__title product-ovr__title_mt50">Approved</h3>
        <div className="product-ovr__tablo">
          <div className="product-ovr__approved">
            <Approved />
          </div>
          <div className="product-ovr__info">
            <LinksBlock className="product-ovr__linksblock" />
            <h3 className="product-ovr__title product-ovr__title_mt47">
              Proposal Status
            </h3>
            <StatusBlock className="product-ovr__statusblock" />
          </div>
        </div>
      </div>
      <Submission className="submission-form_mt110" submitName="Approve" />
    </div>
  );
}
